import { palette } from '../palette';
import baseTheme from '../baseTheme';
export var MuiTypography = {
    // there's a lot of correctives in here for Overpass not measuring
    // the font space from the baseline (it seems like it uses descender instead...)
    root: {
        marginBottom: '-0.4em',
    },
    gutterBottom: {
        marginBottom: '-0.05em',
    },
    h1: {
        color: palette.primary.main,
        marginBottom: '-0.3em',
        '&$gutterBottom': {
            marginBottom: "calc(-0.3em + " + baseTheme.spacing(3) + "px)",
        },
    },
    h2: {
        marginBottom: '-0.3em',
        '&$gutterBottom': {
            marginBottom: "calc(-0.3em + " + baseTheme.spacing(3) + "px)",
        },
    },
    h3: {
        marginBottom: '-0.3em',
        '&$gutterBottom': {
            marginBottom: "calc(-0.3em + " + baseTheme.spacing(3) + "px)",
        },
    },
    h4: {
        color: palette.primary.main,
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        marginBottom: '-0.3em',
        '&$gutterBottom': {
            marginBottom: "calc(-0.3em + " + baseTheme.spacing(3) + "px)",
        },
    },
    h5: {
        marginBottom: '-0.6em',
        '&$gutterBottom': {
            marginBottom: "calc(-0.6em + " + baseTheme.spacing(3) + "px)",
        },
    },
    subtitle1: {
        marginBottom: '-0.7em',
        '&$gutterBottom': {
            marginBottom: "calc(-0.7em + " + baseTheme.spacing(3) + "px)",
        },
    },
    subtitle2: {
        marginBottom: '-0.6em',
        '&$gutterBottom': {
            marginBottom: "calc(-0.6em + " + baseTheme.spacing(3) + "px)",
        },
    },
    h6: {
        marginBottom: '-0.7em',
        '&$gutterBottom': {
            marginBottom: "calc(-0.7em + " + baseTheme.spacing(3) + "px)",
        },
    },
    body1: {
        marginBottom: '-0.6em',
        '&$gutterBottom': {
            marginBottom: "calc(-0.6em + " + baseTheme.spacing(3) + "px)",
        },
    },
    body2: {
        marginBottom: '-0.75em',
        '&$gutterBottom': {
            marginBottom: "calc(-0.75em + " + baseTheme.spacing(3) + "px)",
        },
    },
    caption: {
        fontStyle: 'italic',
        color: baseTheme.palette.text.secondary,
        marginBottom: '-0.6em',
        '&$gutterBottom': {
            marginBottom: "calc(-0.6em + " + baseTheme.spacing(3) + "px)",
        },
    },
};
//# sourceMappingURL=MuiTypography.js.map